// @ts-nocheck

import { formatPercentage, formatMoney, formatThousands } from 'utils/utilities';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import * as React from 'react';
import Label from 'atoms/label/label';
import { Typography } from "antd";

const { Title } = Typography;

const OrderSummary = ({ dataLoading, info }) => {

	return (
		<Stack gutter="medium" align='center'  className='order-status-items'>
			<StackItem className='order-status-item'>
				<Title level={5} style={{ whiteSpace: "nowrap" }}>Shipping</Title>
				<Title level={4} style={{ whiteSpace: "nowrap" }}>{!info?.ShipQty ? 0.0 : formatThousands(info?.ShipQty)} Racks</Title>
			</StackItem>
			<StackItem className='order-status-item'>
				<Title level={5} style={{ whiteSpace: "nowrap" }}>Total Dollars</Title>
				<Title level={4} style={{ whiteSpace: "nowrap" }}>{!info?.OrderCost ? 0 : `${formatMoney(info?.OrderCost)}`}</Title>
			</StackItem>
			<StackItem className='order-status-item'>
				<Title level={5} style={{ whiteSpace: "nowrap" }}>Total Stores</Title>
				<Title level={4} style={{ whiteSpace: "nowrap" }}>{!info?.StoreCount ? 0 : info?.StoreCount}</Title>
			</StackItem>
			<StackItem className='order-status-item'>
				<Title level={5} style={{ whiteSpace: "nowrap" }}>Order Total</Title>
				<Title level={4} style={{ whiteSpace: "nowrap" }}>{formatThousands(info?.OrderQty ?? 0)}</Title>
			</StackItem>
			<StackItem className='order-status-item'>
				<Title level={5} style={{ whiteSpace: "nowrap" }}>% Availability Cost Consumed</Title>
				<Title level={4} style={{ whiteSpace: "nowrap" }}>{formatPercentage(info?.AvailabilityCostConsumed ?? 0)}</Title>
			</StackItem>
			
		</Stack>
	);
};
export default OrderSummary;
